import { gql } from '@apollo/client';

export const GET_DASHBOARD_PRODUCT_TOUR = gql`
  query GetDashboardProductTour($locale: String!) {
    dashboardProductTour(locale: $locale) {
      conclusionTitle
      conclusionText
      introTitle
      introSubtitle
      introBody
      chapters {
        id
        title
        pagePath
        sortOrder
        steps {
          id
          content
          target
          placement
          sortOrder
          proceedInstructions
        }
      }
    }
  }
`;
